const ufeApi = require('services/api/ufeApi');
const urlUtils = require('utils/Url');
const { addBrowseExperienceParams } = require('utils/Api');
const { isSXSSearchEnabled } = require('utils/Cookies');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Type+Ahead+Search+API

function searchTypeAhead(query, includeOnlyProducts = false, suggestions = {}) {
    const constructorSessionID = !!global.ConstructorioTracker && global.ConstructorioTracker.getSessionID();
    const constructorClientID = !!global.ConstructorioTracker && global.ConstructorioTracker.getClientID();
    const isNLPSearchEnabled = Sephora.configurationSettings.isNLPSearchEnabled;
    const isNLPInstrumentationEnabled = Sephora.configurationSettings.isNLPInstrumentationEnabled;
    const lastParam = includeOnlyProducts ? '&includeOnlyProducts=true' : '';
    const { productSuggestions = 6, searchSuggestions = 3 } = suggestions;
    let url = '/api/catalog/search/';

    if (isSXSSearchEnabled()) {
        url = '/api/v2/catalog/search/';
    }

    const type = isSXSSearchEnabled() ? 'typeAhead' : 'typeahead';

    url =
        url +
        `?type=${type}&q=${encodeURIComponent(query)}${lastParam}&searchSuggestions=${searchSuggestions}&productSuggestions=${productSuggestions}`;

    if (isNLPInstrumentationEnabled) {
        if (isNLPSearchEnabled && constructorSessionID && constructorClientID) {
            url = url + `&constructorSessionID=${constructorSessionID}&constructorClientID=${constructorClientID}&targetSearchEngine=nlp`;
        }
    } else {
        url = url + '&targetSearchEngine=nlp';
    }

    const opts = {};
    const config = {
        service: 'search',
        isSXSSearchEnabled: isSXSSearchEnabled()
    };

    addBrowseExperienceParams(opts, config);

    if (Object.keys(opts).length) {
        url += '&' + urlUtils.makeQueryString(opts);
    }

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = searchTypeAhead;
